const liberGreen = {
    400: '#01BA69',
    300: '#18D281',
    200: '#7CE6B8',
    100: '#B5F1D6',
};
export default liberGreen;
